import { Component, Vue } from 'vue-property-decorator'
import { queryClassSummary, queryClassPaperSend, queryPaperClassDetail, editNoteClassDetail, editNotePaperSend, sendPaperClassMessage } from '@/api'
import paperFeedBack from '@/components/paperFeedBack/index.vue'
import urlBase from '@/utils/urlBase'

@Component({ name: 'class-detail-page', components: { paperFeedBack } })
export default class ClassDetailPage extends Vue {
  private classData: any = {}
  private activeweek: any = 0
  private currentStudentPage: any = 1
  private allStudentPage: any = 1
  private activeStudent: any = {}
  private dialogImageUrl: any = null
  private dialogVisible: any = null
  private NotePaperSend: any = false
  // 班级课程内容
  private classPaperData: any = {}
  // 论文投递
  private paperDelivery: any = {}

  created () {
    // 班级详情
    this.initPageData()
    // 论文投递数据
    this.initClassPaperSend()
    // 课程内容
    this.initPaperClassDetail()
  }

  private uploadUrl = {
    // imgs: 'http://192.168.0.33:10069/upload/evaluation/image'
    imgs: urlBase.eduBaseUrl + 'upload/evaluation/image'
  }

  private async initPageData () {
    const result: any = await queryClassSummary({ classId: this.$route.query.classId })
    this.classData = result
    // 班级学生分页
    if (result.studentList.length) {
      this.allStudentPage = Math.ceil(result.studentList.length / 10)
      this.activeStudent = result.studentList[0]
      result.studentList.forEach((item: any) => {
        this.$set(item, 'classId', this.$route.query.classId)
      })
    }
  }

  private async initClassPaperSend () {
    const result = await queryClassPaperSend({ classId: this.$route.query.classId })
    this.classPaperData = result
  }

  private async initPaperClassDetail () {
    const result = await queryPaperClassDetail({ classId: this.$route.query.classId })
    this.paperDelivery = result
  }

  // 保存班级课程内容
  private async saveClassContent () {
    const { error }: any = await editNoteClassDetail({ changeList: this.paperDelivery.question, classId: this.$route.query.classId })
    if (!error) {
      this.$message({ type: 'success', message: '保存课程内容成功', duration: 3000 })
      // this.initPaperClassDetail()
    }
  }

  // 保存班级论文投递
  private async saveNotePaperSen () {
    const { error }: any = await editNotePaperSend({ changeList: this.classPaperData.question })
    if (!error) {
      this.$message({ type: 'success', message: '保存论文投递成功' })
      this.NotePaperSend = true
    }
  }

  // 发送班级反馈
  private async sureSendClassClick (type: any) {
    await this.saveNotePaperSen()
    if (this.NotePaperSend) {
      const { error }: any = await sendPaperClassMessage({ classId: this.$route.query.classId, messageType: type })
      if (!error) {
        this.$message({ type: 'success', message: type === 1 ? '发送论文投递成功' : '更新论文投递成功' })
      }
      this.NotePaperSend = false
    }
  }

  // 上传图片
  private handleRemove1 (obj: any, file: any, fileList: any) {
    if (fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
  }

  private handleSuccess1 (obj: any, response: any, file: any, fileList: any) {
    if (fileList.find((item: any) => item.status !== 'success')) return
    const list: any = []
    if (fileList.length) {
      fileList.forEach((element: any) => {
        const obj1: any = {}
        obj1.name = element.name
        obj1.url = element.response ? element.response.data.url : element.url
        list.push(obj1)
      })
    }
    obj.answer = list
  }

  private handlePictureCardPreview (file: any) {
    this.dialogImageUrl = file.url
    this.dialogVisible = true
  }

  private changeradio (item: any, item1: any) {
    this.$nextTick(() => {
      const obj = item.defaultValue.find((item: any) => item.id === item1)
      item.answer[0].id = obj.id
      item.answer[0].answer = obj.value
    })
  }
}
